<template>
  <b-loading :active="loading" v-if="loading"/>
  <router-view v-else-if="job" :job="job" :employer="employer" :report="report"/>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      job: null,
      employer: null,
      report: null,
      loading: true,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  async created() {
    try {
      this.job = (await this.$http.get(`jobs/${this.$route.params.id}/`)).data;
      if (this.user && this.job.employer !== this.user.id && this.$route.name === 'job-edit') {
        this.$router.replace({ name: 'job-view' });
        return;
      }
      let employer;
      let report = null;
      if (this.user) {
        [{ data: employer }, { data: { results: [report] } }] = await Promise.all([
          this.$http.get(`users/${this.job.employer}/`),
          this.$http.get('job_reports/', { params: { job: this.job.id } }),
        ]);
      } else {
        employer = await this.$http.get(`users/${this.job.employer}/`).data;
      }
      this.employer = employer;
      this.report = report;
    } catch (e) {
      this.$router.replace({ name: 'not-found' });
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
